import { render, staticRenderFns } from "./MyCertificate.vue?vue&type=template&id=57966ea3&scoped=true"
import script from "./MyCertificate.vue?vue&type=script&lang=js"
export * from "./MyCertificate.vue?vue&type=script&lang=js"
import style0 from "./MyCertificate.vue?vue&type=style&index=0&id=57966ea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57966ea3",
  null
  
)

export default component.exports